export const getApiUrl = () => {
    const hostname = window.location.hostname;

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return 'https://localhost:3001';
    }

    // URL do Backend no Firebase App Hosting / Google Cloud
    return 'https://backprd--sindai-474613-k9.us-east4.hosted.app';
};
